import {
	SET_AUTH_LOADING,
	UPDATE_USER,
	RESET_USER,
	UPDATE_TOKENS,
	RESET_TOKENS,
	DefCurrentUser,
	UPDATE_AUTH,
	RESET_AUTH,
} from './actions.js';

export function authLoading(state = false, action) {
	switch (action.type) {
		case SET_AUTH_LOADING:
			//return {...state, ...action.payload};
			return action.status;
		default:
			return state;
	}
}

export function currentUser(state = DefCurrentUser, action) {
	switch (action.type) {
		case UPDATE_USER:
			return { ...state, ...action.payload };
		case RESET_USER:
			return DefCurrentUser;
		default:
			return state;
	}
}

export function tokens(state = {}, action) {
	switch (action.type) {
		case UPDATE_TOKENS:
			return { ...state, ...action.payload };
		case RESET_TOKENS:
			return {};
		default:
			return state;
	}
}

export function authorisation(state = [], action) {
	switch (action.type) {
		case UPDATE_AUTH:
			return action.data;
		case RESET_AUTH:
			return [];
		default:
			return state;
	}
}
